<form class="full-signup base-email-signup">
  <div class="full-signup-form-container">
    <h2 class="subscribe-subhead">{{tagline}}{{^tagline}}Stay up to date on criminal justice, immigration and our analysis.{{/tagline}}</h2>
    <div class="newsletter-options-list">
      {{#newsletters}}
      <label class="newsletter-option-item" tabindex="0">
        <input style="display: none;" type="checkbox" name="{{id}}" value="{{id}}" class="newsletter-option-input" {{#default_subscribe}}checked{{/default_subscribe}}>
        <div class="newsletter-option-checkbox">
          <?xml version="1.0" encoding="utf-8"?>
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.36 55.36" style="enable-background:new 0 0 55.36 55.36;" xml:space="preserve">
            <polyline class="subscribe-checkmark" points="6.29,27.21 23.16,45.21 51.29,9.21 "/>
          </svg>
        </div>
        <div class="newsletter-option-text-container">
          <div class="newsletter-option-title">
            {{name}}
            {{#sample_email_url}}
              <a class="newsletter-option-sample" target="_blank" href="{{sample_email_url}}">Example</a>
            {{/sample_email_url}}
          </div>
          <span class="newsletter-option-frequency">
            {{frequency}}
          </span>
          <span class="newsletter-option-description">
            {{description}}
          </span>
        </div>
      </label>
      {{/newsletters}}
    </div>
    <div class="subscribe-email-container clearfix">
      <div class="subscribe-column">
        {{! This is a honey-pot field for spambots. A real user should never fill it out. }}
        <input type="text" tabindex="-1" hidden name="comment">
        <input type="email" name="email" class="subscribe-email-input" placeholder="Enter your email address" value="{{email}}">
      </div>
      <div class="subscribe-column">
        <div class="subscribe-button-js subscribe-button" aria-role="button" tabindex="0">Sign up</div>
      </div>
    </div>
    <div class="subscribe-managed-label">
      Email list managed by <a class="subscribe-mailchimp-name" target="_blank" rel="noreferrer" href="https://mailchimp.com/legal/privacy/">Mailchimp</a>
    </div>
    <div class="subscribe-error-container"></div>
  </div>

  <div class="full-signup-success-container">
    <h2 class="subscribe-subhead">{{successMessage}}{{^successMessage}}Welcome to our community!{{/successMessage}}</h2>
    <p class="subscribe-next-steps">
      Thanks for trusting us to be your source for urgent investigations and compelling narratives about criminal justice. Readers like you help to make our work possible. Please consider taking the next step and become a member today.
    </p>
    <div class="signup-donate-button-container"><a href="/donate?via={{ donateCampaign }}{{^donateCampaign }}7010d000001PqQZ{{/donateCampaign }}" class="inline-block donate-button">Donate</a></div>
  </div>
</form>
